import { render, staticRenderFns } from "./tablaTransportistas.vue?vue&type=template&id=1142c12f&scoped=true&"
import script from "./tablaTransportistas.vue?vue&type=script&lang=js&"
export * from "./tablaTransportistas.vue?vue&type=script&lang=js&"
import style0 from "./tablaTransportistas.vue?vue&type=style&index=0&id=1142c12f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142c12f",
  null
  
)

export default component.exports